import { IFontFamily } from '@/interfaces/editor'
import { createReducer } from '@reduxjs/toolkit'
import { setFonts, setFontPacks, setFontGroups, setFontsLoading } from './actions'
import { FontGroup } from './types'

export interface FontsState {
  fonts: IFontFamily[]
  fontPacks: IFontFamily[]
  fontGroups: FontGroup
  isLoading: boolean
  isLoaded: boolean
}

const initialState: FontsState = {
  fonts: [],
  fontPacks: [],
  fontGroups: {},
  isLoading: false,
  isLoaded: false,
}

export const fontsReducer = createReducer(initialState, builder => {
  builder
    .addCase(setFonts, (state, { payload }) => {
      state.fonts = payload
    })
    .addCase(setFontPacks, (state, { payload }) => {
      state.fontPacks = payload
    })
    .addCase(setFontGroups, (state, { payload }) => {
      state.fontGroups = payload
      state.isLoaded = true
    })
    .addCase(setFontsLoading, (state, { payload }) => {
      state.isLoading = payload
    })
})
